const StudentCapacityBox = ({ keyText, valueText, highlight }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: highlight ? "#0E141B" : "#FFF",
        border: highlight ? "none" : "1px solid #E6EDEC",
        borderRadius: "16px",
        boxShadow: "0 10px 30px -24px rgba(20,40,50,.2)",
        padding: "16px 20px",
        width: "100%",
        boxSizing: "border-box",
        gap: "8px",
        minWidth: 0,
      }}
    >
      <div
        style={{
          fontSize: "0.78rem",
          fontWeight: 700,
          color: highlight ? "#B9C1C9" : "#7A8490",
          lineHeight: 1.3,
          wordBreak: "keep-all",
        }}
      >
        {keyText}
      </div>
      <div
        style={{
          fontSize: "1.3rem",
          fontWeight: 800,
          color: highlight ? "#00D9C0" : "#00A396",
          textAlign: "right",
          fontVariantNumeric: "tabular-nums",
          letterSpacing: "-0.01em",
        }}
      >
        {valueText}
      </div>
    </div>
  );
};

export default StudentCapacityBox;
